import React from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';

import CartComponent from 'surface_mount_carriers/components/Cart';
import { addToCart } from 'surface_mount_carriers/store/thunks';
import { changeParameter, updateQuantity, updateValidatorFlag, validator } from 'surface_mount_carriers/store/slice';
import { selectDataForCart } from 'surface_mount_carriers/store/selectors';

const Cart = () => {
  const dispatch = useDispatch();
  const {
    quantity,
    parameters,
    quote,
    addingToCart,
  } = useSelector(selectDataForCart);

  const onChangeParameter = (name, value) => {
    dispatch(changeParameter({ name, value }));
  };

  const onChangeQuantity = (value) => {
    dispatch(updateQuantity(value));
    onChangeParameter('quantities', [value]);
  };

  const onAddToCart = async () => {
    try {
      if (validator.allValid()) {
        await dispatch(addToCart()).unwrap();

        // eslint-disable-next-line no-undef
        window.location.href = '/cart';
      } else {
        validator.showMessages();
        dispatch(updateValidatorFlag());
        toast(Spree.translations.project_errors, { type: 'error' });
      };
    } catch (e) {
      toast(Spree.translations.add_to_cart_error, { type: 'error' });
    }
  };


  return (
    <CartComponent
      parameters={parameters}
      quote={quote}
      quantity={quantity}
      onChangeParameter={onChangeParameter}
      onChangeQuantity={onChangeQuantity}
      onAddToCart={onAddToCart}
      addingToCart={addingToCart} />
  );
};

export default Cart;